import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export const Menu = (props) => (
    <div className="row d-flex justify-content-center user-navigation">
        <ul className="nav">
            <li className={`nav-item ${props.active === 'profile' ? 'active' : ''}`}>
                <Link to="/dashboard" className={`nav-link ${props.active === 'profile' ? 'active' : ''}`}>
                    Profile
                </Link>
            </li>
            <li className={`nav-item ${props.active === 'messages' ? 'active' : ''}`}>
                <Link to="/messages" className={`nav-link ${props.active === 'messages' ? 'active' : ''}`}>
                    Messages
                </Link>
            </li>
            {/*
            <li className={`nav-item ${props.active === 'bookings' ? 'active' : ''}`}>
                <Link to="/dashboard/bookings" className={`nav-link ${props.active === 'bookings' ? 'active' : ''}`}>
                    Booking
                </Link>
            </li>
            <li className={`nav-item ${props.active === 'place' ? 'active' : ''}`}>
                <Link to="/dashboard/place" className={`nav-link ${props.active === 'place' ? 'active' : ''}`}>
                    Place
                </Link>
            </li>
            */}
        </ul>
    </div>
)
